module.exports = __webpack_public_path__ + "static/atlaskit-modal-dialog-84e83f85f727eb0d2d0776c728cc2836.png";